// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DATE_JOINED = "D\u00e1tum registr\u00e1cie";
export const IN_LAST_7_DAYS = "Za posledn\u00fdch 7 dn\u00ed";
export const LAST_LOGIN = "Posledn\u00e9 prihl\u00e1senie";
export const LOGIN_NAME_AGE = "Login";
export const LONG_TIME_AGO = "D\u00e1vno";
export const THERE_ARE_MORE_RESULTS = "Tvojmu zadaniu vyhovuj\u00fa aj \u010fal\u0161ie pou\u017e\u00edvate\u013eky, sk\u00fas presnej\u0161ie.";
